



import Image from '@/components/common/Image'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class CarouselSlide extends Vue {
  @Prop({ required: true }) images!: Image[]
  currentIndex = 0

  get activeImage() {
    return this.images[this.currentIndex]
  }

  next() {
    this.currentIndex !== this.images.length - 1
      ? this.currentIndex++
      : this.currentIndex = 0
    this.$forceUpdate()
  }

  previous() {
    this.currentIndex !== 0
      ? this.currentIndex--
      : this.currentIndex = this.images.length - 1
    this.$forceUpdate()
  }
}
